export const DATA_CONFIG = {
  gridConfig: [
     { label: '代码',
     prop: 'code'},
     { label: '名称',
     prop: 'name'},
     { label: '排序',
     prop: 'px'}
	],
	dialogConfig: {
		width: '50%',
		labelWidth: '120px'
	},
  queryConfig: [
  ],
  // crud的模态框表单配置，可配置表单类型，验证规则，是否必填,col-span布局可通过span参数配置
  formConfig: [
	    { span: 24, 
	      label:'代码', 
	      prop: 'code',
	      type: 'text',
		      rules:
		      { required: true,
		        message: '请输入字典表代码',
		        trigger: 'blur'
		      },
	      dataScource:1,
	      data:[]
	      
	    },
	    { span: 24, 
	      label:'名称', 
	      prop: 'name',
	      
	      type: 'text',
		      rules:
		      { required: true,
		        message: '请输入字典表名称',
		        trigger: 'blur'
		      },
	      dataScource:1,
	      data:[]
	      
	    },
	    { span: 24, 
	      label:'排序', 
	      prop: 'px',
	      
	      type: 'text',
		      rules:
		      { required: true,
		        message: '请输入排序',
		        trigger: 'blur'
		      },
	      dataScource:1,
	      data:[]
	      
	    }
  ],
 gridTopBtnConfig: [{
   'name': '新建',
   'type': null,
   'classify': 'create',
   'index': 0,
   'location': 'top',
   'roles': [],
   'modelId': null,
   'actionUrl': ''
 }],
 gridBtnConfig: [
   {
     'name': '修改',
     'type': null,
     'classify': 'update',
     'index': 1,
     'location': 'grid',
     'roles': [],
     'actionUrl': ''
   },
   {
     'name': '删除',
     'type': null,
     'classify': 'delete',
     'index': 2,
     'location': 'grid',
     'roles': [],
     'modelId': null,
     'actionUrl': ''
   }
 ],
  // crud的操作按钮配置，基础按钮有添加、修改、删除、查看，还可以配置扩展按钮
  // gridBtnConfig: {
  //   create: true, update: true, delete: true, view: false,
    
  // },
  // 表单基础数据类型，需要预先赋值
  formModel: {
    'id': '',
    'code': '',  	
    
    'name': '',  	
    
    'px': '',  	
    
    'type': '',  	
    
  },
  queryModel:{
  }
} 



// WEBPACK FOOTER //
// ./src/components/generator/sysDict/config/config.js